import img1 from '../images/projects-1.jpg';
import img2 from '../images/projects-2.jpg';
import img3 from '../images/projects-3.jpg';
import img4 from '../images/projects-4.jpg';
import img5 from '../images/projects-5.jpg';

const data = [
  {
    title: 'Amazon Chime',
    subtitle: 'Sign-in & Web Viewer UI Engineering, 2017',
    url: 'https://chime.aws',
    img: img1,
    bgColor: '#1f2749'
  },
  {
    title: 'Amazon WorkDocs Rebranding',
    subtitle: 'Design, 2016',
    url: 'https://aws.amazon.com/workdocs/',
    img: img4,
    bgColor: '#33273c'
  },
  {
    title: 'WorkDocs Threaded Commenting',
    subtitle: 'Design, 2016',
    url: 'https://aws.amazon.com/workdocs/',
    img: img3,
    bgColor: '#33273c'
  },
  {
    title: 'Amazon Work Suite Icon',
    subtitle: 'Icon System & Plug-in Engineering, 2016',
    url: 'https://aws.amazon.com',
    img: img2,
    bgColor: '#292E3A'
  },
  {
    title: 'Amazon Sync Client',
    subtitle: 'Design, 2016',
    url: 'https://aws.amazon.com/workdocs/',
    img: img5,
    bgColor: '#33273c'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/data/WorkSuiteItems.js